import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function CtaSection() {
  return <section className="px-4 mb-16 text-center" data-id="element-26">
      <div className="bg-card p-8 md:p-10 rounded-3xl shadow-diary border-2 border-forest/10" data-id="element-27">
        <h2 className="font-handwriting text-4xl md:text-5xl font-bold text-forest mb-4" data-id="element-28">
          Lass dein Futter endlich richtig wirken
        </h2>

        <p className="font-serif text-lg text-text/80 mb-8 max-w-md mx-auto" data-id="element-29">
          Mit dem Magen-Darm-Topping holst du mehr aus jedem Napf heraus –
          risikofrei testen.
        </p>

        <a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-forest hover:bg-forest/90 text-cream font-serif font-bold text-lg px-8 py-4 rounded-full transition-all transform hover:scale-105 active:scale-95 shadow-lg mb-6" data-id="element-30">
          Jetzt für meinen Hund entdecken
          <ArrowRight size={20} data-id="element-31" />
        </a>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm font-serif text-brown/80" data-id="element-32">
          <div className="flex items-center gap-1.5" data-id="element-33">
            <CheckCircle2 size={16} className="text-forest" data-id="element-34" />
            <span data-id="element-35">Schneller Versand</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-36">
            <CheckCircle2 size={16} className="text-forest" data-id="element-37" />
            <span data-id="element-38">Zufriedenheitsgarantie</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-39">
            <CheckCircle2 size={16} className="text-forest" data-id="element-40" />
            <span data-id="element-41">100% Natürliche Inhaltsstoffe</span>
          </div>
        </div>
      </div>
    </section>;
}